const anchorScroll = () => {
  $('a[href*="#"]').on('click', function () {
    let href = $(this).attr("href");
    if (href.indexOf('#') >= 0) {
      let targetId = href.substr(href.indexOf('#'));
      let target = $(targetId == "#" || targetId == "" ? 'body' : targetId);
      const headerHight = $('.header').outerHeight();
      let pos = target.offset().top - headerHight;
      $("html, body").animate({ scrollTop: pos }, 600, "swing");
    }
  });
}
export { anchorScroll }
